module.exports = __webpack_public_path__ + "static/bg-happy_hockey-mobile-1421a3b4cacf427a5cfce8b8e2e47bda.jpg";